import firebaseApp from './firebase'

const db = firebaseApp.firestore();

export default db;